import { useMutation } from '@apollo/client';
import * as Sentry from '@sentry/react';

import logger from 'js/app/loggerSingleton';

import ENTERPRISE_USERS_RESEND_VERIFICATION_EMAIL_MUTATION from 'bundles/enterprise-legacy-learner-home/queries/EnterpriseUsersResendVerificationEmail.graphql';
import type {
  EnterpriseUsers_ResendVerificationEmailMutation as ResendVerificationEmailMutation,
  EnterpriseUsers_ResendVerificationEmailMutationVariables as ResendVerificationEmailMutationVariables,
} from 'bundles/enterprise-legacy-learner-home/queries/__generated__/EnterpriseUsersResendVerificationEmail';

export function useResendVerificationEmail() {
  const [resendEmail] = useMutation<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>(
    ENTERPRISE_USERS_RESEND_VERIFICATION_EMAIL_MUTATION,
    {
      context: { clientName: 'gatewayGql' },
    }
  );

  const resendVerificationEmail = async (params: { orgSlug: string; email: string }) => {
    try {
      const response = await resendEmail({
        variables: {
          input: {
            orgSlug: params.orgSlug,
            email: params.email,
          },
        },
      });

      if (
        response.data?.EnterpriseUsers_ResendVerificationEmail.__typename ===
        'EnterpriseUsers_ResendVerificationEmailResultFailure'
      ) {
        throw new Error(response.data.EnterpriseUsers_ResendVerificationEmail.error);
      }

      return response.data?.EnterpriseUsers_ResendVerificationEmail;
    } catch (e) {
      logger.error('Failed to resend verification email', e);
      Sentry.captureException(e as Error);
      throw e;
    }
  };

  return {
    resendVerificationEmail,
  };
}
